import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { UsuarioSharedModule } from './usuario-shared.module';
import { RepresentanteModule } from '../pessoa/representante';
import { UnidadeNegocioSharedModule } from '../unidade-negocio';
import { UsuarioInfobarModule } from './infobar';
import { UsuarioEmailAssinaturaUploadModule } from './email/assinatura-upload';
import { UsuarioEmailAdministrativoFormModule } from './email/administrativo/form';

import { UsuarioRoutingModule } from './usuario-routing.module';
import { UsuarioComponent } from './usuario.component';
import { UsuarioFormComponent } from './form';
import { UsuarioExpedicaoComponent } from './expedicao';
import { UsuarioMarcaComponent } from './marca';
import { UsuarioLinhaComponent } from './linha';
import { UsuarioPermissaoComponent, UsuarioPermissaoCadastroComponent, UsuarioPermissaoPedidoComponent, UsuarioPermissaoIntegracaoComponent, UsuarioPermissaoClienteComponent, UsuarioPermissaoAnaliseMercadoComponent, UsuarioPermissaoCampanhaComponent, UsuarioPermissaoMetaComponent, UsuarioPermissaoPLMComponent } from './permissao';
import { UsuarioAcessosComponent } from './acessos';
import { UsuarioFilterCollapseComponent } from './filter';
import { UsuarioUnidadeNegocioComponent } from './unidade-negocio';
import { UsuarioBadgeSituacaoComponent } from './components/badge-situacao/badge-situacao.component';
import { UsuarioBadgeEventoAcessoComponent } from './components/badge-evento-acesso/badge-evento-acesso.component';
import { LogComponent } from './components/log/log.component';
import { LogSituacaoTableComponent } from './components/log-situacao-table/log-situacao-table.component';
import { LogAcessoTableComponent } from './components/log-acesso-table/log-acesso-table.component';
import { FormInativarUsuarioModal } from './modals/form-inativar/form-inativar-usuario.modal';
import { FormReativarUsuarioModal } from './modals/form-reativar/form-reativar-usuario.modal';
import { SelectUsuarioNivelVisualizacaoPedidoDrpComponent } from './components/select-usuario-nivel-visualizacao-pedido-drp/select-usuario-nivel-visualizacao-pedido-drp.component';

@NgModule({
    imports: [
        SharedModule,
        UsuarioSharedModule,
        UsuarioRoutingModule,
        RepresentanteModule,
        UnidadeNegocioSharedModule,
        UsuarioInfobarModule,
        UsuarioEmailAssinaturaUploadModule,
        UsuarioEmailAdministrativoFormModule
    ],
    declarations: [
        UsuarioComponent,
        UsuarioFormComponent,
        UsuarioExpedicaoComponent,
        UsuarioMarcaComponent,
        UsuarioLinhaComponent,
        UsuarioFilterCollapseComponent,
        UsuarioPermissaoComponent,
        UsuarioPermissaoCadastroComponent,
        UsuarioPermissaoPedidoComponent,
        UsuarioPermissaoClienteComponent,
        UsuarioPermissaoAnaliseMercadoComponent,
        UsuarioPermissaoCampanhaComponent,
        UsuarioPermissaoMetaComponent,
        UsuarioPermissaoPLMComponent,
        UsuarioPermissaoIntegracaoComponent,
        UsuarioUnidadeNegocioComponent,
        UsuarioAcessosComponent,
        UsuarioBadgeSituacaoComponent,
        UsuarioBadgeEventoAcessoComponent,
        LogComponent,
        LogSituacaoTableComponent,
        LogAcessoTableComponent,
        FormInativarUsuarioModal,
        FormReativarUsuarioModal,
        SelectUsuarioNivelVisualizacaoPedidoDrpComponent
    ]
})
export class UsuarioModule { }
